import React from "react";

const formatCompetitionPeriod = (start, end) => {
    if (start && end) return `${start} - ${end}`;
    return start || end || "";
};

const headerCell = {
    padding: "10px 12px",
    textAlign: "left",
    fontWeight: 700,
    fontSize: "13px",
    color: "#fff",
    background: "#58A2E4",
    whiteSpace: "nowrap",
    letterSpacing: "0.02em"
};

const bodyCell = {
    padding: "9px 12px",
    borderBottom: "1px solid #e6eef5",
    fontSize: "13px",
    whiteSpace: "nowrap"
};

const serverLabel = (selected, disabled) => ({
    display: "inline-block",
    minWidth: "52px",
    padding: "2px 10px",
    borderRadius: "999px",
    textAlign: "center",
    fontWeight: 700,
    fontSize: "12px",
    letterSpacing: "0.04em",
    lineHeight: "18px",
    background: disabled ? "#e4e4e4" : selected ? "rgba(255,255,255,0.22)" : "#e7f3fc",
    color: disabled ? "#888" : selected ? "#fff" : "#1a6eac",
    border: disabled ? "1px solid #d5d5d5" : selected ? "1px solid rgba(255,255,255,0.55)" : "1px solid #b7daf4"
});

const AggregateCompetitionLoad = ({competitions = [], selectedCompetition, onSelect}) => {

    return (
        <div
            style={{
                width: "100%",
                height: "420px",
                overflow: "auto",
                background: "#fff",
                borderRadius: "6px",
                border: "1px solid #d5e6f2",
                boxShadow: "0 1px 2px rgba(88, 162, 228, 0.15)"
            }}
        >
            <table
                style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    tableLayout: "fixed"
                }}
            >
                <thead>
                <tr style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 2,
                    boxShadow: "0 2px 0 #3d8ad4"
                }}>
                    <th style={{...headerCell, width: "64px"}}>ID</th>
                    <th style={headerCell}>Название</th>
                    <th style={{...headerCell, width: "188px"}}>Дата проведения</th>
                    <th style={{...headerCell, width: "148px"}}>Дата агрегации</th>
                    <th style={{...headerCell, width: "110px"}}>Сервер</th>
                </tr>
                </thead>

                <tbody>
                {competitions.map((el, index) => {
                    const disabled = Boolean(el.is_modify) && el.profile !== "view";
                    const selected = selectedCompetition === el.competition_id;
                    return (
                        <tr
                            key={el.competition_id}
                            onClick={() => {
                                if (!disabled) onSelect(el.competition_id);
                            }}
                            style={{
                                cursor: disabled ? "not-allowed" : "pointer",
                                background: disabled
                                    ? "#f3f3f3"
                                    : selected
                                        ? "#2f7fc4"
                                        : index % 2
                                            ? "#f4f9fd"
                                            : "#fff",
                                color: disabled ? "#999" : selected ? "#fff" : "#24323c",
                                transition: "0.15s"
                            }}
                        >
                            <td style={bodyCell}>
                                {el.competition_id}
                            </td>
                            <td
                                title={el.competition_name || ""}
                                style={{
                                    ...bodyCell,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis"
                                }}
                            >
                                {el.competition_name}
                            </td>
                            <td style={bodyCell}>
                                {formatCompetitionPeriod(el.date_start, el.date_end)}
                            </td>
                            <td style={bodyCell}>
                                {el.aggregated_at || ""}
                            </td>
                            <td style={bodyCell}>
                                {el.server
                                    ? <span style={serverLabel(selected, disabled)}>{el.server}</span>
                                    : ""}
                            </td>
                        </tr>
                    );
                })}
                </tbody>
            </table>
        </div>
    );
};

export default AggregateCompetitionLoad;
